<template>
  <div></div>
</template>

<script>
import { onLogin } from '@/vue-apollo'

export default {
  async created () {
    const searchParams = new URLSearchParams(window.location.search)

    if (searchParams.has('token') && searchParams.has('refresh')) {
      await onLogin(this.$apollo.getClient(), searchParams.get('token'), searchParams.get('refresh'), true)
      await this.$router.push({ name: 'Home' })
    } else {
      await this.$router.push({ name: 'auth_login' })
    }
  }
}
</script>
